export const getStyled = (theme) => ({
  actionButtons: {
    marginRight: 6,
    maxWidth: '100%',
    flex: 'none',
    alignSelf: 'center',
    marginLeft: 'auto',
    display: 'flex',
    gap: 5,
  },
  bottomButtonVisibilityIcon: {
    padding: 1,
    color: theme.palette.mode === 'light' ? '#1DA1F2' : '#FFF',
  },
  botoes: {
    display: 'flex',
    padding: '15px',
    justifyContent: 'flex-end',
    maxWidth: '100%',
  },
});
